module.exports = __webpack_public_path__ + "img/service_content_img.3553ebe0.jpg";